module.exports = __webpack_public_path__ + "img/security-shield-lock.8ac4163d.svg";